var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"containerg plata_card_response_section"},[_c('div',{staticClass:"title_politica"},[_vm._v(_vm._s(_vm.$t('comanda_refuzata')))]),_c('div',{staticClass:"container_politica"},[_vm._v(" Plata a fost refuzata. "),_c('a',{on:{"click":function($event){return _vm.goToCheckout()}}},[_vm._v("Reincearca plata")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }